import { render, staticRenderFns } from "./FileInputForm.vue?vue&type=template&id=9a04782e&scoped=true"
import script from "./FileInputForm.vue?vue&type=script&lang=js"
export * from "./FileInputForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a04782e",
  null
  
)

export default component.exports